
/**
 * Formats a date string (or Date instance) to "DD-MM-YYYY"
 * @param {string|Date|null|undefined} dateInput
 * @returns {string|null}
 */
export function formatDDMMYYYY(dateInput: string | number | Date) {
    if (!dateInput) return null;
    const d = dateInput instanceof Date ? dateInput : new Date(dateInput);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }
  